import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  registerUser,
  verifyAndSendToken,
  checkNeedRegister,
  checkLoggedin
} from '../../actions/users'
import { loadSiteApplication } from '../../actions/siteapplications'
import _ from 'lodash'
import {
  SwxTheme,
  Container,
  Box,
  Notification,
  NotificationDesc,
  NotificationTitle,
  Modal
} from 'swx-atomic-component-lib'
import SelfRegisterForm from './selfRegisterForm'
import TempCodeVerification from '../tempCodeVerifcation'
import i18n from '../../i18n'

import queryStringFunc from '../../helpers/query-string'

const { x3, x6 } = SwxTheme.sizing

function RegisterNew (props) {
  const [error, setError] = useState({})
  const [queryString, setQueryString] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [refreshCaptcha, setRefreshCaptcha] = useState(false)
  const [isAlreadyLoggedIn, setIsAlreadyLoggedIn] = useState(false)
  const [checkLoggedInDone, setCheckLoggedInDone] = useState(false)

  const {
    registerUser,
    history,
    checkLoggedin,
    loadSiteApplication
  } = props

  useEffect(() => {
    const qs = queryStringFunc()

    if (!_.isEmpty(_.trim(queryString.email))) {
      qs.email = decodeURIComponent(qs.email)
    }

    setQueryString(qs)

    // check if the user already logged in
    checkLoggedin()
      .then(() => {
        setIsAlreadyLoggedIn(true)
        setCheckLoggedInDone(true)
      }).catch(() => {
        setIsAlreadyLoggedIn(false)
        setCheckLoggedInDone(true)
      })

    // not using this checkNeedRegister function for the moment.
    // checkNeedRegister(qs)
    //   .then(response => {
    //     if (response && response.value && response.value.data && !_.isEmpty(response.value.data)) {
    //       const {success, baseUrl, token, alreadyLogged = false, user: userFromAPI = {}, name} = response.value.data

    //       if (success === false && !_.isEmpty(baseUrl)) {
    //         const returnUrl = decodeURIComponent(qs.return)
    //         const haveQueryString = !_.isNull(returnUrl.match(/\?/))
    //         window.location.href = baseUrl + returnUrl + `${haveQueryString ? `&token=${token}` : `?token=${token}`}`
    //         return
    //       }

    //       if (success && alreadyLogged === true && !_.isEmpty(userFromAPI)) {
    //         // Already register with smarterWx
    //         setShowEULA(true)
    //         setIsExisting(true)
    //       } else {
    //         setIsExisting(false)
    //       }

    //       if (success && !_.isEmpty(baseUrl) && !_.isEmpty(name)) {
    //         // Self Register
    //         setAppBaseUrl(baseUrl)
    //         setAppName(name)
    //       }

    //       const prefillForm = { firstName: '', lastName: '', phone: '', email: '' }

    //       if (!_.isEmpty(userFromAPI.first_name)) {
    //         prefillForm.firstName = userFromAPI.first_name
    //       }
    //       if (!_.isEmpty(userFromAPI.last_name)) {
    //         prefillForm.lastName = userFromAPI.last_name
    //       }
    //       if (!_.isEmpty(userFromAPI.phone_number)) {
    //         prefillForm.phone = userFromAPI.phone_number
    //       }
    //       if (!_.isEmpty(userFromAPI.email)) {
    //         prefillForm.email = userFromAPI.email
    //       }

    //       setUser({...prefillForm})
    //     } else {
    //       throw new Error('Some error happen when fetching the response object!')
    //     }
    //   })
    //   .catch(err => setError(err.response || {}))
  }, [])

  useEffect(() => {
    if (isAlreadyLoggedIn) {
      window.location = '/appLauncher'
    }
  }, [isAlreadyLoggedIn])

  useEffect(() => {
    if (!_.isEmpty(error)) {
      const { status, statusText, data = {} } = error
      console.error(`${statusText}: ${JSON.stringify(data.message)}`)

      switch (status) {
        case 403:
          history.push('/')
          break
        case 400:
          break
        case 500:
          break
        default:
      }
    }
  }, [error])

  useEffect(() => {
    if (refreshCaptcha) {
      setRefreshCaptcha(false)
    }
  }, [refreshCaptcha])

  function onSubmit (value) {
    const {
      firstName,
      lastName,
      email,
      phone,
      password,
      passwordAgain,
      recaptcha
    } = value
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    const registerByInvitation = false

    const data = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      password,
      password_confirmation: passwordAgain,
      timezone,
      recaptcha
    }

    if (!_.isEmpty(queryString.lead)) {
      data.lead = queryString.lead
    }

    setIsLoading(true)
    setError({})

    setTimeout(() => {
      if (!registerByInvitation) {
        registerUser(data).then(results => {
          setIsLoading(false)
          setEmail(email)
          setIsModalOpen(true)
        }, err => {
          setIsLoading(false)
          setError(err.response || {})
          setRefreshCaptcha(true)
        })
      }
    }, 1000)
  }

  function onGoToSignIn () {
    if (!_.isEmpty(queryString) && queryString.clientId) {
      history.push(`/login?clientId=${queryString.clientId}&return=/`)
    } else {
      history.push('/login')
    }
  }

  function closeModal () {
    setIsModalOpen(false)
  }

  return (
    <Container customStyle={container} className='swx-background'>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        pl={x3}
        pr={x3}
        h={x6}
        w='calc(100vw)'
        bgColor={SwxTheme.palette.g50}
        bb={`1px solid ${SwxTheme.palette.g400}`}
        customStyle='position: absolute; top: 0; left: 0;'
        className='mobile-hide'
      >
        <Box renderAs='img' src='./black.svg' w={110} height={24} />
      </Box>
      <Container customStyle={innerContainer} className='mobile-form-container mobile-center'>
        <Box display='flex' className='col-s-6 mobile-center'>
          <Link to='/'>
            <Box
              renderAs='img'
              src='./black.svg'
              alt='SmarterWX Identity Logo'
              className='swx-logo-black'
            />
          </Link>
        </Box>
        <Box customStyle={marketingHeader} className='mobile-only'>
          {i18n.registerNewPage.marketing.locate.header}
        </Box>
        {checkLoggedInDone && !isAlreadyLoggedIn && (
          <Box customStyle={registerForm}>
            <SelfRegisterForm
              submitForm={onSubmit}
              goToSignIn={onGoToSignIn}
              goToAppLauncher={() => history.push('/')}
              loadSiteApplication={loadSiteApplication}
              loading={isLoading}
              refreshCaptcha={refreshCaptcha}
            />
          </Box>
        )}
      </Container>
      {
        !_.isEmpty(error) && (
          <Notification type='error' customStyle={notificationStyle}>
            <NotificationTitle>{i18n.registerNewPage.notification.error.title}</NotificationTitle>
            <NotificationDesc>{error.data.message}</NotificationDesc>
          </Notification>
        )
      }
      <Modal customStyle='overflow:hidden' open={isModalOpen}>
        <Box display='flex'>
          <TempCodeVerification
            email={email}
            closeModal={closeModal}
            module='register'
            needVerify
          />
        </Box>
      </Modal>
    </Container>
  )
}

function mapStateToProps (state) {
  return {
    self: state.self
  }
}

const container = `
  display: flex;
  overflow: auto;
  justify-content: center;
  align-items: center;
  background-image: url(/shapes-025-lines-large.svg);
  background-repeat: no-repeat;
  background-position: -275px -190px;
  height: 100vh;
  width: 100vw;
  @media only screen and (max-width: 600px) {
    height: auto !important;
    width: auto !important;
  }
`
const innerContainer = `
  @media only screen and (min-width: 600px) {
    display: flex !important;
  }
`
const marketingHeader = `
    width: 328px;
    height: 219px;
    background-image: linear-gradient(#686868, #373737);
    padding: 83px 32px 40px 32px;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #22ff00;
    display: flex;
    align-items: center;
    @media only screen and (max-width: 600px) {
      height: 120px !important;
      width: 100% !important;
      font-size: 17px !important;
      padding: 30px 24px !important;
      margin-top: 24px !important;
    }
`
// Margin left calc - logo length - icon width - icon margin right
const registerForm = `
  @media only screen and (min-width: 600px) {
    width: 640px !important;
    height: 100% !important;
    min-height: 503px;
    padding: 40px 40px 0px 40px; !important
  }
  margin-left: auto;
  margin-right: auto;
`
const notificationStyle = `
  position: fixed;
  top: 48px;
  left: 0px;
  width: 100%;
  
  @media only screen and (max-width: 600px) {
    top: 0px;
  }
`
export default connect(mapStateToProps, { registerUser, verifyAndSendToken, checkNeedRegister, checkLoggedin, loadSiteApplication })(RegisterNew)
